import React from 'react';

import Icon from '@atlaskit/icon';
import { CustomGlyphProps } from '@atlaskit/icon/types';

const codeSuggestionsGlyph = (props: CustomGlyphProps) => (
  <svg
    {...props}
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.776 6.57387C1.776 3.91562 4.568 1.75262 8 1.75262C11.432 1.75262 14.224 3.91562 14.224 6.57387C14.224 9.233 11.432 11.3951 8 11.3951C4.568 11.3951 1.776 9.233 1.776 6.57387ZM14.9671 13.3735V13.3717C14.9671 13.3717 13.5769 11.3942 14.2853 10.6453L14.2524 10.6628C15.3431 9.53925 16 8.11912 16 6.57387C16 2.94962 12.4116 0 8 0C3.58844 0 0 2.94875 0 6.57387C0 10.199 3.58844 13.1486 8 13.1486C9.26222 13.1486 10.4533 12.8992 11.5173 12.4696C12.4089 13.3639 13.5502 13.8451 14.3973 13.9737L14.3991 13.9711C14.4458 13.9884 14.495 13.9981 14.5449 14C14.6205 14 14.6949 13.9815 14.7615 13.9463C14.8281 13.9111 14.8847 13.8602 14.9265 13.7981C14.9682 13.7361 14.9937 13.6648 15.0006 13.5907C15.0075 13.5166 14.9966 13.442 14.9671 13.3735Z"
      fill="#44546F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.04421 4.14005C7.144 4.23168 7.19945 4.35208 7.19945 4.47709C7.19945 4.6021 7.144 4.7225 7.04421 4.81413L5.16956 6.50045L7.04421 8.18587C7.144 8.2775 7.19945 8.3979 7.19945 8.52291C7.19945 8.64793 7.144 8.76832 7.04421 8.85995C6.99642 8.90397 6.93847 8.9391 6.874 8.96312C6.80952 8.98714 6.73991 8.99955 6.66955 8.99955C6.59918 8.99955 6.52957 8.98714 6.46509 8.96312C6.40062 8.9391 6.34267 8.90397 6.29488 8.85995L4.23303 7.00544C4.08327 6.86799 4.00004 6.68735 4.00004 6.49977C4.00004 6.3122 4.08327 6.13156 4.23303 5.9941L6.29488 4.1396C6.34267 4.09557 6.40062 4.06045 6.46509 4.03642C6.52957 4.0124 6.59918 4 6.66955 4C6.73991 4 6.80952 4.0124 6.874 4.03642C6.93847 4.06045 6.99642 4.09603 7.04421 4.14005ZM8.95566 4.14005C9.00345 4.09603 9.0614 4.0609 9.12588 4.03688C9.19035 4.01286 9.25996 4.00045 9.33033 4.00045C9.4007 4.00045 9.4703 4.01286 9.53478 4.03688C9.59926 4.0609 9.65721 4.09603 9.70499 4.14005L11.7668 5.99456C12.0778 6.27364 12.0778 6.72636 11.7668 7.0059L9.70499 8.8604C9.65721 8.90443 9.59926 8.93955 9.53478 8.96358C9.4703 8.9876 9.4007 9 9.33033 9C9.25996 9 9.19035 8.9876 9.12588 8.96358C9.0614 8.93955 9.00345 8.90443 8.95566 8.8604C8.85572 8.76875 8.80018 8.64826 8.80018 8.52314C8.80018 8.39802 8.85572 8.27753 8.95566 8.18587L10.8303 6.50045L8.95566 4.81413C8.85588 4.7225 8.80042 4.6021 8.80042 4.47709C8.80042 4.35208 8.85588 4.23168 8.95566 4.14005Z"
      fill="#172B4D"
    />
  </svg>
);

export const CodeSuggestionsIcon = (): JSX.Element => {
  return (
    <Icon glyph={codeSuggestionsGlyph} label="Code Suggestions" size="small" />
  );
};
